<article class="flex-1 flex-column">
  <div class="toolbar top" [style.width.px]="getToolbarTopWidth()" [style.left.px]="productionScheduleVerifyMargin.left">
    <div class="toolbar-top-content">
      <div
        *ngIf="canShowZoneIndicator(selectedZone)"
        class="zone-indicator"
        [class.rest-zone]="productionScheduleZoneComponent.isZonesInstanceOfRestZone(selectedZone)"
        [class.free-zone]="productionScheduleZoneComponent.isZonesInstanceOfFreeZone(selectedZone)"
        [style.left.px]="getZoneIndicatorPosition()"
      ></div>
    </div>

    <app-production-schedule-zones
      class="free-zones-container"
      *ngIf="canShowFreeAndRestZonesEditor()"
      [suggestedZones]="suggestedFreeZones"
      [aspectRatio]="aspectRatio"
      [productionSchedule]="productionSchedule"
      [productionScheduleVerifyWidth]="getProductionScheduleVerifyWidth()"
      [zones]="productionSchedule.freeZones"
    ></app-production-schedule-zones>
  </div>

  <div #productionScheduleVerifyContainer (scroll)="onScrollProductionScheduleVerifyContainer($event)" class="production-schedule-verify-container">
    <div class="content flex-column" [style.width.px]="getContentWidth()">
      <div #verifyHeader class="flex-1 flex-row flex-start-end verify-header overflow-hidden">
        <div class="verify-header-filler" [style.min-width.px]="productionScheduleVerifyMargin.left"></div>

        <div
          class="verify-header-wrapper flex-row"
          *ngFor="
            let productionSchedulePathsOfColoredYarnSet of productionSchedule.productionSchedulePathsOfColoredYarnSets;
            let productionScheduleColoredYarnSetIndex = index;
            trackBy: trackByProductionSchedulePathsOfColoredYarnSet
          "
          [style.width.px]="getProductionScheduleColoredYarnSetWidth(productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet)"
        >
          <div
            class="production-schedule-path-container"
            *ngFor="let item of productionSchedule | getProductionSchedulePathsAndZonesForColoredYarnSet: productionScheduleColoredYarnSetIndex : productionSchedulePhase; let itemIndex = index"
          >
            @if (isProductionSchedulePath(item)) {
              <div class="production-schedule-path-header flex-column" [style.width.px]="getWidthInDentsWithAspectRatio(item.technicalWidthInDents)">
                <div *ngIf="canShowHeader(getWidthInDentsWithAspectRatio(item.technicalWidthInDents))" class="flex-row flex-start-center full-width">
                  <ng-container *appHasPermission="permissionToViewBuggyLength">
                    <ng-container *ngIf="canShowMaximumBuggyLengthWarningForProductionSchedulePathsOfColoredYarnSet(productionSchedulePathsOfColoredYarnSet)">
                      <mat-icon
                        *ngIf="canShowMinimumBuggyLengthWarningForProductionSchedulePath(item)"
                        class="small-icon"
                        svgIcon="warning"
                        [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.CONFIRMATION.WARNINGS.PATH_LENGTH_IS_TOO_SHORT' | bmsTranslate"
                        matTooltipPosition="above"
                        matTooltipClass="unset-max-width unset-max-width-warning"
                      ></mat-icon>
                      <mat-icon
                        *ngIf="canShowMaximumBuggyLengthWarningForProductionSchedulePath(item)"
                        class="small-icon"
                        svgIcon="warning"
                        [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.CONFIRMATION.WARNINGS.MAX_PATH_LENGHT_HAS_BEEN_CROSSED' | bmsTranslate"
                        matTooltipPosition="above"
                        matTooltipClass="unset-max-width unset-max-width-warning"
                      ></mat-icon>
                    </ng-container>
                  </ng-container>

                  <vdw-ellipsis-label
                    class="flex-no-grow path-label"
                    matTooltipPosition="above"
                    [text]="getProductionSchedulePathLabel(item, getWidthInDentsWithAspectRatio(item.technicalWidthInDents))"
                  >
                  </vdw-ellipsis-label>

                  <mat-divider vertical></mat-divider>

                  <app-color-list-preview-with-position
                    #colorListPreviewComponents
                    [isSisal]="productionSchedule.machine.jacquard.isSisal"
                    [coloredYarnSet]="productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet"
                    [style.width.px]="getWidthInDentsWithAspectRatio(item.technicalWidthInDents)"
                    [creelMapping]="productionSchedule.mappingForCurrentPositionOnMachine ? this.productionSchedule.mappingForCurrentPositionOnMachine[productionScheduleColoredYarnSetIndex] : null"
                  ></app-color-list-preview-with-position>
                </div>
              </div>
            } @else if (isRestZone(item) && item.technicalWidthInDents > 0) {
              <div class="flex-row full-width" [style.width.px]="getWidthInDentsWithAspectRatio(item.technicalWidthInDents)">
                <p class="rest-label" matTooltipPosition="above" [matTooltip]="getRestZoneTooltip(item)">
                  {{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.REST' | bmsTranslate }}
                </p>
              </div>
            }

            <div class="production-schedule-zone-header flex-column" *ngIf="!isProductionSchedulePath(item)" [style.width.px]="getWidthInDentsWithAspectRatio(item.technicalWidthInDents)"></div>
          </div>

          <div class="flex-1 flex-column gap-8 rest-container" *ngIf="!isProductionSchedulePhaseVerify()">
            <app-color-list-preview-with-position
              #colorListPreviewComponents
              [isSisal]="productionSchedule.machine.jacquard.isSisal"
              [coloredYarnSet]="productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet"
              [creelMapping]="productionSchedule.mappingForCurrentPositionOnMachine ? this.productionSchedule.mappingForCurrentPositionOnMachine[productionScheduleColoredYarnSetIndex] : null"
            ></app-color-list-preview-with-position>

            <vdw-ellipsis-label class="micro" matTooltipPosition="above" [text]="getRestLabelForProductionSchedulePathsOfColoredYarnSet(productionSchedulePathsOfColoredYarnSet) | uppercase">
            </vdw-ellipsis-label>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="vertical-axis-container">
          <vdw-distance-specifier
            [containerWidthInPx]="productionScheduleVerifyHeight"
            [technicalDistance]="getMinimumProductionScheduleVerifyTechnicalHeight()"
            [commercialDistanceInMM]="getMinimumProductionScheduleVerifyInMM()"
            [orientation]="distanceSpecifierOrientation.VERTICAL"
          ></vdw-distance-specifier>
          <svg:svg class="vertical-axis-wrapper" [attr.height]="productionScheduleVerifyHeight" width="51">
            <svg:g #productionScheduleVerifyVerticalAxis class="vertical-axis-indications"></svg:g>
          </svg:svg>
        </div>

        <svg:svg
          [attr.width]="getOriginProductionScheduleVerifyWidth()"
          [attr.height]="productionScheduleVerifyHeight"
          [appRunEventsOutsideAngular]="['dragover', 'dragleave', 'drop']"
          (outSideAngularEvent)="preventDefaultEvent($event)"
          *ngIf="canShowProductionScheduleVerify"
          #productionScheduleVerify
        >
          <svg:g class="production-schedule-verify-group" #productionScheduleVerifyGroup>
            <svg:svg
              app-production-schedule-colored-yarn-set
              class="production-schedule-colored-yarn-set"
              y="0"
              *ngFor="
                let productionSchedulePathsOfColoredYarnSet of productionSchedule.productionSchedulePathsOfColoredYarnSets;
                let productionScheduleColoredYarnSetIndex = index;
                trackBy: trackByProductionSchedulePathsOfColoredYarnSet
              "
              [productionSchedule]="productionSchedule"
              [commercialUnit]="commercialUnit"
              [aspectRatio]="aspectRatio"
              [productionSchedulePhase]="productionSchedulePhase"
              [productionSchedulePathsOfColoredYarnSet]="productionSchedulePathsOfColoredYarnSet"
              [productionScheduleColoredYarnSetIndex]="productionScheduleColoredYarnSetIndex"
              [productionScheduleBuilderHeight]="productionScheduleVerifyHeight"
              [isEditPathsEnabled]="isEditPathsEnabled"
              [productionOrderCustomSettings]="productionOrderCustomSettings"
              [isProductionScheduleDisplayOverview]="isProductionScheduleDisplayOverview()"
              (hoveredProductionSchedulePathComponent)="hoveredProductionSchedulePathComponent($event)"
              (productionSchedulePlanChanged)="onProductionSchedulePlanChanged()"
            ></svg:svg>

            <ng-container *ngIf="canShowRestZones()">
              <svg:svg class="rest-zones" *ngFor="let restZone of productionSchedule.restZones" [attr.x]="getZonePosition(restZone)">
                <svg:rect *ngIf="canShowZone(restZone)" class="zone rest-zone" [attr.width]="getZoneWidth(restZone)" [attr.height]="productionScheduleVerifyHeight"></svg:rect>
                <line
                  *ngIf="isZoneSelected(restZone)"
                  [attr.x1]="getZoneIndicatorLineHorizontalPosition(restZone)"
                  y1="0"
                  [attr.x2]="getZoneIndicatorLineHorizontalPosition(restZone)"
                  [attr.y2]="productionScheduleVerifyHeight"
                  class="zone-indicator-line rest-zone"
                ></line>
              </svg:svg>
            </ng-container>

            <ng-container *ngIf="canShowFreeZones()">
              <svg:svg class="free-zones" *ngFor="let freeZone of productionSchedule.freeZones" [attr.x]="getZonePosition(freeZone)">
                <svg:rect *ngIf="canShowZone(freeZone)" class="zone free-zone" [attr.width]="getZoneWidth(freeZone)" [attr.height]="productionScheduleVerifyHeight"></svg:rect>
                <line
                  *ngIf="isZoneSelected(freeZone)"
                  [attr.x1]="getZoneIndicatorLineHorizontalPosition(freeZone)"
                  y1="0"
                  [attr.x2]="getZoneIndicatorLineHorizontalPosition(freeZone)"
                  [attr.y2]="productionScheduleVerifyHeight"
                  class="zone-indicator-line free-zone"
                ></line>
              </svg:svg>
            </ng-container>

            <ng-container *appHasPermission="permissionToViewBuggyLength">
              <svg:g *ngIf="canShowProductionScheduleVerifyMinBuggyLengthIndicator()">
                <svg:line
                  class="buggy-length-indicator min"
                  x1="0"
                  [attr.y1]="getProductionScheduleVerifyMinBuggyLengthPosition()"
                  [attr.x2]="getProductionScheduleVerifyWidth()"
                  [attr.y2]="getProductionScheduleVerifyMinBuggyLengthPosition()"
                ></svg:line>
                <svg:line
                  #minBuggyLengthIndicator
                  class="interaction-area"
                  x1="0"
                  [attr.y1]="getProductionScheduleVerifyMinBuggyLengthPosition()"
                  [attr.x2]="getProductionScheduleVerifyWidth()"
                  [attr.y2]="getProductionScheduleVerifyMinBuggyLengthPosition()"
                  [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.MINIMUM_LENGTH' | bmsTranslate"
                ></svg:line>
              </svg:g>

              <svg:g *ngIf="canShowProductionScheduleVerifyMaxBuggyLengthIndicator()">
                <svg:line
                  class="buggy-length-indicator max"
                  x1="0"
                  [attr.y1]="getProductionScheduleVerifyMaxBuggyLengthPosition()"
                  [attr.x2]="getProductionScheduleVerifyWidth()"
                  [attr.y2]="getProductionScheduleVerifyMaxBuggyLengthPosition()"
                ></svg:line>
                <svg:line
                  #maxBuggyLengthIndicator
                  class="interaction-area"
                  x1="0"
                  [attr.y1]="getProductionScheduleVerifyMaxBuggyLengthPosition()"
                  [attr.x2]="getProductionScheduleVerifyWidth()"
                  [attr.y2]="getProductionScheduleVerifyMaxBuggyLengthPosition()"
                  [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.MAXIMUM_LENGTH' | bmsTranslate"
                ></svg:line>
              </svg:g>
            </ng-container>
          </svg:g>
        </svg:svg>
      </div>
    </div>

    <div class="toolbar bottom" [style.width.px]="getContentWidth()">
      <div class="horizontal-axis" [style.margin-left.px]="productionScheduleVerifyMargin.left"></div>

      <app-production-schedule-zones
        class="rest-zones-container"
        *ngIf="canShowFreeAndRestZonesEditor()"
        [style.margin-left.px]="productionScheduleVerifyMargin.left"
        [suggestedZones]="suggestedRestZones"
        [aspectRatio]="aspectRatio"
        [productionSchedule]="productionSchedule"
        [productionScheduleVerifyWidth]="getProductionScheduleVerifyWidth()"
        [zones]="productionSchedule.restZones"
      ></app-production-schedule-zones>

      <div class="path-distance-specifier-container">
        <div #verifyHeader class="flex-1 flex-row flex-start-end verify-header">
          <div class="verify-header-filler" [style.min-width.px]="productionScheduleVerifyMargin.left"></div>

          <div
            class="verify-header-wrapper flex-row"
            *ngFor="
              let productionSchedulePathsOfColoredYarnSet of productionSchedule.productionSchedulePathsOfColoredYarnSets;
              let productionScheduleColoredYarnSetIndex = index;
              trackBy: trackByProductionSchedulePathsOfColoredYarnSet
            "
            [style.width.px]="getProductionScheduleColoredYarnSetWidth(productionSchedulePathsOfColoredYarnSet.productionScheduleColoredYarnSet)"
          >
            <div
              class="production-schedule-path-container flex-end-center flex-column"
              *ngFor="let item of productionSchedule | getProductionSchedulePathsAndZonesForColoredYarnSet: productionScheduleColoredYarnSetIndex : productionSchedulePhase; let itemIndex = index"
            >
              <div *ngIf="isProductionSchedulePath(item)" [style.width.px]="getWidthInDentsWithAspectRatio(item.technicalWidthInDents)"></div>

              <div class="production-schedule-path-header flex-column" *ngIf="isProductionSchedulePath(item)" [style.width.px]="getWidthInDentsWithAspectRatio(item.technicalWidthInDents)">
                <p
                  *ngIf="canShowTotalHeight(getWidthInDentsWithAspectRatio(item.technicalWidthInDents))"
                  [ngClass]="getFlexDirection(getWidthInDentsWithAspectRatio(item.technicalWidthInDents))"
                  class="total-height-label flex-center"
                >
                  <span class="font-weight-bold">{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.TOTAL_HEIGHT' | bmsTranslate }}:</span>
                  <span>{{ getTotalHeight(item, getWidthInDentsWithAspectRatio(item.technicalWidthInDents)) }}</span>
                </p>

                <vdw-distance-specifier
                  [containerWidthInPx]="getWidthInDentsWithAspectRatio(item.technicalWidthInDents)"
                  [technicalDistance]="item.technicalWidthInDents"
                  [commercialDistanceInMM]="item.commercialWidthInMM"
                ></vdw-distance-specifier>
              </div>

              <div class="flex-column" *ngIf="!isProductionSchedulePath(item)" [style.width.px]="getWidthInDentsWithAspectRatio(item.technicalWidthInDents)"></div>
            </div>
          </div>
        </div>
      </div>

      <div [style.margin-left.px]="productionScheduleVerifyMargin.left">
        <vdw-distance-specifier
          [containerWidthInPx]="getProductionScheduleVerifyHorizontalAxisWidth()"
          [technicalDistance]="getProductionScheduleVerifyTechnicalWidth()"
          [commercialDistanceInMM]="getProductionScheduleVerifyCommercialWidth()"
        ></vdw-distance-specifier>
      </div>
    </div>
  </div>
</article>
